import { UserAuthz, UserRole } from "components/Login";
import { useContext, useMemo } from "react";

/**
 * Custom hook to check if the current user has any of the specified roles
 * @param roles - A single role, array of roles, or "all" to allow any user
 * @returns boolean indicating whether the user has the required role(s)
 */
export const useHasRole = (roles: UserRole | UserRole[] | "all"): boolean => {
  const userAuthz = useContext(UserAuthz);

  return useMemo(() => {
    if (roles === "all") {
      return true;
    }
    if (Array.isArray(roles)) {
      return roles.some((r) => userAuthz.has(r));
    }
    return userAuthz.has(roles);
  }, [roles, userAuthz]);
};
